export default "__VITE_ASSET__SE032MVB__"